import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { useFetchPostV2 } from "hooks/fetch/useFetchPostV2";
import { UNKNOWN } from "core/constants";

export default function useSaveFailureType() {
  const {
    loading: createFailureTypeLoading,
    error: createFailureTypeError,
    postCallback: createFailureType
  } = useFetchPostV2("failure_types");

  const {
    loading: failureTypesLoading,
    error: failureTypesError,
    response: failureTypes,
    refetch: refetchFailureTypes
  } = useFetchGetV2("failure_types?size=99999");

  async function saveFailureType(newFailureType) {
    const existingFailureMode = failureTypes?.results?.find(
      x => x.name === newFailureType
    );

    if (existingFailureMode) return existingFailureMode.id;

    if (newFailureType.length === 0) {
      const existingUnknownFailureMode = failureTypes?.results?.find(
        x => x.name === UNKNOWN
      );

      if (existingUnknownFailureMode) return existingUnknownFailureMode.id;
    }

    try {
      const failureModeSaveResult = await createFailureType({
        name: newFailureType
      });
      await refetchFailureTypes();

      if (failureModeSaveResult?.id) return failureModeSaveResult?.id;
    } catch (error) {
      console.error(error);
    }
  }

  function getInitialFailureType(failureTypeId) {
    const existingFailureMode = failureTypes?.results?.find(
      x => x.id === failureTypeId
    );

    return existingFailureMode?.name ?? UNKNOWN;
  }

  const failureTypesReady =
    !failureTypesLoading && !failureTypesError && Boolean(failureTypes);

  return {
    saveFailureType,
    getInitialFailureType,
    failureTypesReady,
    createFailureTypeLoading,
    createFailureTypeError
  };
}
